exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#App .airwallex,.modal .airwallex{min-height:300px;position:relative}#App .airwallex__loading,.modal .airwallex__loading{position:absolute;left:0;right:0;top:0;bottom:0;display:flex;flex-direction:column;align-items:center;justify-content:center}#App .airwallex__loading div,.modal .airwallex__loading div{position:relative;top:auto}\n", ""]);

// exports
